import React, { FC } from 'react';
import get from 'lodash/get';
import size from 'lodash/size';
import styled, { css } from 'styled-components';

import AdminTooltip from 'src/presentation/components/common/AdminTooltip';
import BusinessHours from 'src/models/BusinessHours/BusinessHours';
import businessHoursResource from 'src/actions/businessHours/businessHoursResource';
import BusinessHoursReference from 'src/models/BusinessHours/BusinessHoursReference';
import businessHoursReferencesResource from 'src/actions/businessHours/businessHoursReferencesResource';
import { Copy } from 'src/presentation/components/pages/shared/rowActions/Copy';
import CopyFillIcon from '@ad-scripts/presentation/components/common/icons/fill/copy-fill';
import { Delete } from 'src/presentation/components/pages/shared/rowActions/Delete';
import { Edit } from 'src/presentation/components/pages/shared/rowActions/Edit';
import RemoveFillIcon from '@ad-scripts/presentation/components/common/icons/fill/remove-fill';
import { StyledDeleteButton } from '../shared/DeleteButton';
import { useResourceValue } from 'src/presentation/hooks/useDocumentResource';

type ColumnConfigItem = {
  attr: string;
  label: string;
};

type RowActionProps = {
  columnConfig: ColumnConfigItem[];
  dataAid?: string;
  item: BusinessHours;
  openReferencesModal: (item: BusinessHours, references: BusinessHoursReference[]) => void;
  renderRowAction: Function;
};

const RowActions: FC<RowActionProps> = ({ item, openReferencesModal }) => {
  const { value } = useResourceValue(businessHoursReferencesResource);

  const references = get(value, item.id);

  const handleOpenDeleteModal = callbackOpenModal => {
    const quantity = size(references);
    !quantity ? callbackOpenModal() : openReferencesModal(item, references);
  };

  return (
    <>
      <Copy dataAid={`copyLink-${item.id}`} id={item.id} copyIcon={StyledCopyIcon} />
      <Edit dataAid={`editLink-${item.id}`} id={item.id} />
      {item.primary ? (
        <StyledDeleteButton data-aid={`primary-delete-button-${item.id}`}>
          <AdminTooltip delay={250} message="Unable to delete the Primary Business Hours">
            <DisabledTrashIcon data-aid="primary-delete-icon" />
          </AdminTooltip>
        </StyledDeleteButton>
      ) : (
        <Delete
          confirmationText={item.name}
          deleteAction={businessHoursResource.effects.remove}
          deleteIcon={StyledTrashIcon}
          description="Are you sure you want to delete?"
          handleOpenModal={handleOpenDeleteModal}
          id={item.id}
          submitText="Delete Business Hours"
        />
      )}
    </>
  );
};

const iconFillStyles = css`
  fill: ${p => p.theme.colors.gray600};
`;
const StyledTrashIcon = styled(RemoveFillIcon)`
  ${iconFillStyles}
`;

const DisabledTrashIcon = styled(RemoveFillIcon)`
  fill: ${p => p.theme.colors.gray400};
`;

const StyledCopyIcon = styled(CopyFillIcon)`
  ${iconFillStyles}
`;

export default RowActions;
